/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const StarHollow: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M14.959 8.20605L15.1924 8.67773L15.7119 8.75391L22.3271 9.71582L17.54 14.377L17.1631 14.7441L17.252 15.2627L18.3828 21.8535L12.4648 18.7461L12 18.502L11.5352 18.7471L5.61523 21.8555L6.74609 15.2686L6.83594 14.75L6.45898 14.3838L1.6709 9.72168L8.28809 8.75391L8.80762 8.67871L9.04004 8.20703L11.999 2.20996L14.959 8.20605Z'
      stroke='currentColor'
      fill='transparent'
      strokeWidth='2'
    />
  </React.Fragment>
)
